import { Outlet } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { User } from '@clan-heart/shared';
import { canManage } from '@clan-heart/shared';
import { Header } from '../components/Header.js';
import { getClaims, getRecruits, logout } from '../api.js';
import styles from './Shell.module.css';

export function Shell({ me }: { me: User }) {
  const queryClient = useQueryClient();
  const manages = canManage(me.role);

  // Only managers see the Review/Roster nav items, so only they need the
  // counts that badge them — avoids extra requests for every member on
  // every page.
  const pendingQuery = useQuery({
    queryKey: ['claims', { status: 'pending' }],
    queryFn: () => getClaims({ status: 'pending' }),
    enabled: manages,
  });

  const pendingRecruitsQuery = useQuery({
    queryKey: ['recruits'],
    queryFn: getRecruits,
    enabled: manages,
  });

  const signOut = useMutation({
    mutationFn: logout,
    onSuccess: () => {
      queryClient.setQueryData(['me'], null);
      queryClient.clear();
    },
  });

  return (
    <div className={styles.shell}>
      <Header
        me={me}
        pendingCount={pendingQuery.data?.claims.length}
        pendingRecruitsCount={pendingRecruitsQuery.data?.recruits.length}
        onSignOut={() => signOut.mutate()}
      />
      {/* not a <main>: the cave's <main> in PublicLayout already wraps the members' area */}
      <div className={styles.main}>
        <Outlet />
      </div>
    </div>
  );
}
